import { render } from "./Play.vue?vue&type=template&id=7883e1d2&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import "./Play.vue?vue&type=style&index=0&id=7883e1d2&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-7883e1d2"

export default script